import React from 'react'
import Layout from '../../Layout/Layout'
import lama from '../../images/lama.PNG'


const Meta_AI_LIama = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>Meta AI  LIama 3.0 Hackathon</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The Llama 3.1 Impact Sub-Saharan Africa Hackathon held in Kigali October
                         2024 was a significant initiative designed to stimulate Artificial Intelligence (AI)
                          innovation across the continent by leveraging the power of Meta's Llama platform. 
                          Funded by Meta and the Bill & Melinda Gates Foundation (BMGF), the project focused
                           on developing AI solutions that directly address pressing social impact issues 
                           within Africa. Moolu Venture Lab participated in the program as an Independent 
                           Reviewer for AfriLabs, evaluating a specific batch of applications. 
</p>

                <p className='light'>Despite receiving the project on very short notice and having a tight
                     deadline, the Moolu Venture Lab team efficiently reviewed 58 applications based on 
                     the provided criteria. The rigorous process led to the shortlisting of 25 promising 
                     projects, demonstrating the team's commitment to quality and efficiency even under
                      challenging conditions. Key recommendations for future hackathons included
                       incorporating follow-up interviews and providing an extended review time 
                       for a more thorough assessment of the innovative solutions.
</p>
               </div>

                <div className='uk-width-1-2@s'>
                  <img src= {lama} />
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default Meta_AI_LIama